import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CollapseIconButton from './CollapseIconButton'
import { Flex } from 'reflexbox'
import { Link } from 'react-router-dom'
import ClientLink from 'components/routes/Link/ClientLink'
import CreateLink from './CreateLink'
import { IconButton } from 'react-toolbox/lib/button'
import { hideOnReadOnly } from 'helpers/projectUtil'
import { compose } from 'recompose'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

const InfoButton = notifyHoc(IconButton)
const UpdateButton = hideOnReadOnly(ClientLink)

const Actions = (props) => {
  const {
    id,
    toggleCollapse,
    collapse,
    cloneProject
  } = props
  return (
    <Flex justify='flex-end'>
      <CreateLink to={'/project/overview'}>
        <InfoButton
          message={T.translate('pages.project.view.notification.clone')}
          icon='library_add'
          onClick={cloneProject}
        />
      </CreateLink>
      <UpdateButton to={`/project/${id}/update`}>
        <InfoButton
          message={T.translate('pages.project.view.notification.editSpec')}
          icon='edit'
        />
      </UpdateButton>
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
